import FocusableModal from '@components/FocusableModal';
import { useModalContext } from '@context/Modal';
import Delivery from '@pages/Delivery';
import DoctorSelection from '@pages/DoctorSelection';
import EndInstruction from '@pages/EndInstruction';
import Exit from '@pages/Exit';
import Main from '@pages/Main';
import Matching from '@pages/Matching';
import MatchingFail from '@pages/MatchingFail';
import PatientNameInput from '@pages/PatientSetting/views/PatientNameInput';
import PatientResidentRegistrationNumberInput from '@pages/PatientSetting/views/PatientResidentRegistrationNumberInput';
import PatientSelection from '@pages/PatientSetting/views/PatientSelection';
import PaymentRegistration from '@pages/Payment/PaymentRegistration';
import PaymentSelection from '@pages/Payment/PaymentSelection';
import PersonalInformationAgreement from '@pages/PatientSetting/views/PersonalInformationAgreement';
import PostPayment from '@pages/PostPayment';
import Prescription from '@pages/Prescription';
import RetryPayment from '@pages/RetryPayment';
import SignIn from '@pages/SignIn';
import SignOut from '@pages/SignOut';
import TreatmentHistory from '@pages/TreatmentHistory';
import TreatmentHistoryDetail from '@pages/TreatmentHistoryDetail';
import VideoCall from '@pages/VideoCall';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import AuthGuard from './AuthGuard';
import {
  ADVERTISEMENT,
  DELIVERY,
  DOCTOR_SELECTION,
  END_INSTRUCTION,
  EXIT,
  HISTORY,
  HISTORY_DETAIL,
  MATCHING,
  MATCHING_FAIL,
  PATIENT,
  PAYMENT,
  POST_PAYMENT,
  PRESCRIPTION,
  RETRY_PAYMENT,
  ROOT,
  SIGN_IN,
  SIGN_OUT,
  VIDEO_CALL
} from './path';
import PaymentComplete from '@pages/Payment/PaymentComplete';
import Advertisement from '@pages/Advertisement';

const Router = () => {
  const location = useLocation();
  const { visible } = useModalContext();

  return (
    <div>
      <Routes location={location} key={location.pathname}>
        <Route path={ROOT} element={<Main />} />
        <Route
          path={DOCTOR_SELECTION.UNTACT_DEPARTMENT_ID}
          element={<DoctorSelection />}
        />
        <Route path={DOCTOR_SELECTION.DOCTOR_ID} element={<DoctorSelection />} />
        <Route
          path={PATIENT.ROOT}
          element={
            <AuthGuard>
              <PatientSelection />
            </AuthGuard>
          }
        />
        <Route
          path={PATIENT.NAME}
          element={
            <AuthGuard>
              <PatientNameInput />
            </AuthGuard>
          }
        />
        <Route
          path={PATIENT.RRN}
          element={
            <AuthGuard>
              <PatientResidentRegistrationNumberInput />
            </AuthGuard>
          }
        />
        <Route
          path={PATIENT.AGREEMENT}
          element={
            <AuthGuard>
              <PersonalInformationAgreement />
            </AuthGuard>
          }
        />

        <Route
          path={PAYMENT.SELECT}
          element={
            <AuthGuard>
              <PaymentSelection />
            </AuthGuard>
          }
        />
        <Route
          path={PAYMENT.REGISTRATION}
          element={
            <AuthGuard>
              <PaymentRegistration />
            </AuthGuard>
          }
        />
        <Route
          path={PAYMENT.TREATMENT_ID}
          element={
            <AuthGuard>
              <PaymentComplete />
            </AuthGuard>
          }
        />

        <Route
          path={MATCHING}
          element={
            <AuthGuard>
              <Matching />
            </AuthGuard>
          }
        />
        <Route
          path={MATCHING_FAIL}
          element={
            <AuthGuard>
              <MatchingFail />
            </AuthGuard>
          }
        />
        <Route
          path={VIDEO_CALL}
          element={
            <AuthGuard>
              <VideoCall />
            </AuthGuard>
          }
        />
        <Route
          path={END_INSTRUCTION}
          element={
            <AuthGuard>
              <EndInstruction />
            </AuthGuard>
          }
        />
        <Route
          path={HISTORY}
          element={
            <AuthGuard>
              <TreatmentHistory />
            </AuthGuard>
          }
        />
        <Route
          path={HISTORY_DETAIL}
          element={
            <AuthGuard>
              <TreatmentHistoryDetail />
            </AuthGuard>
          }
        />
        <Route
          path={POST_PAYMENT.TYPE_ID}
          element={
            <AuthGuard>
              <PostPayment />
            </AuthGuard>
          }
        />
        <Route
          path={RETRY_PAYMENT.TREATMENT_ID}
          element={
            <AuthGuard>
              <RetryPayment />
            </AuthGuard>
          }
        />
        <Route
          path={PRESCRIPTION.TREATMENT_ID}
          element={
            <AuthGuard>
              <Prescription />
            </AuthGuard>
          }
        />
        <Route
          path={DELIVERY.METHOD}
          element={
            <AuthGuard>
              <Delivery />
            </AuthGuard>
          }
        />
        <Route path={ADVERTISEMENT} element={<Advertisement />} />
        <Route path={SIGN_IN} element={<SignIn />} />
        <Route path={SIGN_OUT} element={<SignOut />} />
        <Route path={EXIT} element={<Exit />} />
        {/* for tizen studio */}
        <Route path="/index.html" element={<Navigate replace to={ROOT} />} />
      </Routes>
      {visible && <FocusableModal />}
    </div>
  );
};

export default Router;
